// Number tags (UX spec 3.3): each phone number gets one of eight hues, shown as a square swatch
// beside its label so an agency user sees at a glance which brand they are calling as. The label is
// always shown with it; colour is never the only cue.
//
// The API has no stored tag hue yet (contract request in UX spec 15), so the hue is derived from the
// number's ID: the same number has the same hue on every screen, for every user and after a reload.
// Two numbers can share a hue; their labels still tell them apart.

export const TAG_HUES = ['indigo', 'teal', 'plum', 'ochre', 'slate', 'rose', 'olive', 'cobalt'] as const;
export type TagHue = (typeof TAG_HUES)[number];

/** The hue for a phone number, from its ID (32-bit FNV-1a, so it is stable across builds). */
export function tagHueFor(numberId: string): TagHue {
  let hash = 0x811c9dc5;
  for (let i = 0; i < numberId.length; i++) {
    hash ^= numberId.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return TAG_HUES[hash % TAG_HUES.length] ?? 'slate';
}

/** The label a number is shown by; a number without one still gets words beside its swatch. */
export function numberTagLabel(number: { label?: string | null }): string {
  return number.label?.trim() || 'No label';
}
